export default __webpack_public_path__ + "static/media/header-xl-2x.bc8fbe81.png";